var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"projects__orther"},[_c('div',{staticClass:"projects__block"},[_c('div',{staticClass:"projects__content"},[_c('h1',{staticClass:"projects__content__title"},[_vm._v(_vm._s(_vm.header.projectsOther))])])]),_c('div',{staticClass:"projects__slider"},[_c('Carousel2',{attrs:{"data":_vm.data,"arrowCenterOptional":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }